var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login__page"},[_c('app-header'),_c('b-container',[_c('div',{staticClass:"content__wrapper"},[_c('b-container',{attrs:{"fluid":""}},[_c('div',{staticClass:"h-100"},[_c('router-view')],1)])],1)]),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }